import React, { useState } from "react";
import PropTypes from "prop-types";

import { useQuery } from "react-apollo";

import { Column, Field, Control } from "rbx";
import { LocationSelect } from "../../../components/inputs";

import FilterButtons from "../../../components/FilterButtons";

import { ALL_DIRECTIONS_QUERY } from "../../../graphql/Directions/Directions.graphql";

const INITIAL_FILTER_STATE = {};

function DirectionFilters({ filters, onFilter, onClose }) {
  const [inputs, setInputs] = useState({});

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    if (value === "0") {
      const keys = Object.keys(inputs).filter(key => key !== e.target.name);
      setInputs({
        ...keys.reduce((acc, curr) => ({ [curr]: inputs[curr] }), {})
      });
    } else {
      setInputs(prevInputs => ({
        ...prevInputs,
        [e.target.name]: e.target.name.includes("RecIdRef")
          ? parseInt(value)
          : value
      }));
    }
  };

  const { data: originData } = useQuery(ALL_DIRECTIONS_QUERY, {
    variables: {
      where: {
        OriginLocationRecIdRef: inputs.OriginLocationRecIdRef
      }
    }
  });
  const { data: destData } = useQuery(ALL_DIRECTIONS_QUERY, {
    variables: {
      where: {
        DestinationLocationRecIdRef: inputs.DestinationLocationRecIdRef
      }
    }
  });
  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <React.Fragment>
      <Column.Group>
        <Column>
          <Field>
            <Control expanded>
              <LocationSelect
                icon="map-pin"
                label="Origin Location"
                name="OriginLocationRecIdRef"
                value={inputs?.OriginLocationRecIdRef}
                where={{
                  RecId_in: destData?.Directions
                    ? [
                        ...new Set(
                          destData.Directions.map(d => d.OriginLocationRecIdRef)
                        )
                      ]
                    : null
                }}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field kind="group">
            <Control expanded>
              <LocationSelect
                icon="map-pin"
                label="Destination Location"
                name="DestinationLocationRecIdRef"
                value={inputs?.DestinationLocationRecIdRef}
                where={{
                  RecId_in: originData?.Directions
                    ? [
                        ...new Set(
                          originData.Directions.map(
                            d => d.DestinationLocationRecIdRef
                          )
                        )
                      ]
                    : null
                }}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>

      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </React.Fragment>
  );
}
DirectionFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};
export default DirectionFilters;
